import React, { Component } from 'react';
import {
  Create,
  SimpleForm,
  SelectInput,
  LongTextInput
} from 'react-admin';
import { Api } from '../../services';
import CustomToolbar from '../customToolbar';

class TooltipOptionCreateMRI extends Component {

  state = {
    tooltipsKeys: []
  };

  getTooptipKeys = async () => {
    const response = await Api.tooltips.getMRIOptionTooltips();
    const responseTooltips = await Api.tooltips.getMRIOptionTooltipsSet();

    let usedKeys = responseTooltips.data
      .filter(element => (parseInt(this.props.id) !== element.id))
      .map(obj => obj.elementName);

    let allowedKeys = [];
    if(response.status === 200) {
      allowedKeys = response.data.data.filter(el => !usedKeys.includes(el.id))
    
      allowedKeys.push({id: '', name: 'None'})

      this.setState({
        tooltipsKeys: allowedKeys
      })
    }
  }
  
  componentDidMount() {
    this.getTooptipKeys()
  }

  render() {
    return (
      <Create {...this.props} >
        <SimpleForm toolbar={<CustomToolbar />} redirect={`/options-tooltip`} >
          <SelectInput
            source="elementName"
            label="Element Name"
            sort={{field: 'name', order: 'ASC'}}
            choices={this.state.tooltipsKeys}
          />
          <LongTextInput source="text" resettable />
        </SimpleForm>
      </Create>
    );
  }
}

export { TooltipOptionCreateMRI };
